(function () {
    const disableAdblocker = {
        init() {
            disableAdblocker.set.variables();
            if (disableAdblocker.hasAdBlock() && disableAdblocker.displayPopup()) {
                disableAdblocker.$modal.modal('show');
                disableAdblocker.controls();
            }
        },
        set: {
            variables() {
                disableAdblocker.$modal = $('#DisableAdBlocker');
                disableAdblocker.isUserLogedin =
                    document.querySelector('.pb-page') &&
                    document.querySelector('.pb-page').hasAttribute('data-pb-user-name');
                disableAdblocker.adblockerContinueBtn = document.querySelector('.disable-adblocker__continue-btn');
                disableAdblocker.adblockerDisableBtn = document.querySelector('.disable-adblocker__disable-btn');
                disableAdblocker.adblockerActionsBack = document.querySelectorAll('.actions__back');
                disableAdblocker.adblockerBlockersButtons = document.querySelectorAll('.blockers .blocker button');
            },
        },
        controls() {
            disableAdblocker.adblockerDisableBtn.addEventListener('click', e => {
                disableAdblocker.slideContent(e, '-100%');
            });

            disableAdblocker.adblockerContinueBtn.addEventListener('click', () => {
                disableAdblocker.isUserLogedin
                    ? localStorage.setItem('hideAdBlock', true)
                    : sessionStorage.setItem('hideAdBlock', true);
            });

            disableAdblocker.adblockerActionsBack.forEach(elem => {
                elem.addEventListener('click', e => {
                    disableAdblocker.slideContent(e, '0');
                });
            });
            disableAdblocker.adblockerBlockersButtons.forEach(elem => {
                elem.addEventListener('click', e => {
                    const blockerType = elem.getAttribute('data-blockerType');
                    disableAdblocker.openTab(e, blockerType);
                });
            });
        },
        hasAdBlock() {
            const t = document.createElement('div');
            (t.innerHTML = '&nbsp;'),
                (t.className =
                    'adsbox pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads adglare-ad-server text-ad-links');
            let e = !(t.style =
                'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;');
            try {
                document.body.appendChild(t);
                let a = document.getElementsByClassName('adsbox')[0];
                if (((0 !== a.offsetHeight && 0 !== a.clientHeight) || (e = !0), void 0 !== window.getComputedStyle)) {
                    const d = window.getComputedStyle(a, null);
                    !d ||
                        ('none' !== d.getPropertyValue('display') && 'hidden' !== d.getPropertyValue('visibility')) ||
                        (e = !0);
                }
                document.body.removeChild(t);
            } catch (a) {
                console.error(a);
            }
            return e;
        },
        displayPopup() {
            return disableAdblocker.isUserLogedin
                ? !localStorage.getItem('hideAdBlock')
                : !sessionStorage.getItem('hideAdBlock');
        },
        slideContent(e, value) {
            e.preventDefault();
            e.stopImmediatePropagation();
            document.querySelector('.disable-adblocker__content').style.transform = `translateX(${value})`;
            document.querySelector('.disable-adblocker__instructions').style.transform = `translateX(${value})`;
        },
        openTab(evt, tabContentId) {
            const tabcontent = document.querySelectorAll('.tabcontent');
            const blockers = document.querySelectorAll('.blocker-list .blocker button');
            tabcontent.forEach(tab => {
                tab.style.display = 'none';
            });
            blockers.forEach(blocker => {
                blocker.classList.remove('active');
            });
            document.getElementById(tabContentId).style.display = 'block';
            evt.currentTarget.classList.add('active');
        },
    };

    UX.disableAdblocker = disableAdblocker;
    document.addEventListener('DOMContentLoaded', () => {
        if (document.getElementById('DisableAdBlocker')) {
            UX.disableAdblocker.init();
        }
    });
})();
